var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 220,
    viewBox: "0 0 247 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.841797 85.2135C0.841797 38.4421 38.7575 0.526367 85.529 0.526367C132.3 0.526367 170.216 38.4421 170.216 85.2136C170.216 131.985 132.3 169.901 85.529 169.901H0.841797V85.2135Z",
    fill: "#BCC5EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.641 154.409C246.641 118.475 217.511 89.3446 181.577 89.3446C145.642 89.3446 116.512 118.475 116.512 154.409C116.512 190.343 145.642 219.474 181.577 219.474H246.641V154.409Z",
    fill: "#BAE4E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M170.062 90.3774C168.063 123.727 146.764 151.876 117.183 163.804C116.741 160.742 116.512 157.611 116.512 154.426C116.512 122.421 139.62 95.8135 170.062 90.3774Z",
    fill: "#FEA7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/speech-bubble.74675bab3f680995c39db674a0dd345b.svg";
export { ForwardRef as ReactComponent };